import { useState, useEffect } from "react";
import { getAboutData } from "@/api/aboutApi";

export interface CompanyInfo {
  companyName: string;
  slogan: string;
  logo: string;
  logoDark: string;
  phone: string;
  email: string;
  address: string;
  wechat: string;
}

const EMPTY: CompanyInfo = {
  companyName: "",
  slogan: "",
  logo: "",
  logoDark: "",
  phone: "",
  email: "",
  address: "",
  wechat: "",
};

let cached: CompanyInfo | null = null;
let fetchPromise: Promise<CompanyInfo> | null = null;

/** 全局单例获取公司信息，多组件共享同一份数据 */
function fetchCompanyInfo(): Promise<CompanyInfo> {
  if (cached) return Promise.resolve(cached);
  if (fetchPromise) return fetchPromise;
  fetchPromise = getAboutData()
    .then((res: any) => {
      const contact = res.contact || {};
      const intro = res.companyIntro || {};
      cached = {
        companyName: contact.companyName ?? intro.title ?? "",
        slogan: contact.slogan ?? intro.desc1 ?? "",
        logo: contact.logo ?? "",
        logoDark: contact.logoDark ?? contact.logo_dark ?? "",
        phone: contact.phone ?? "",
        email: contact.email ?? "",
        address: contact.address ?? "",
        wechat: contact.wechat ?? "",
      };
      return cached;
    })
    .catch(() => {
      cached = EMPTY;
      return EMPTY;
    });
  return fetchPromise;
}

export function useCompanyInfo() {
  const [info, setInfo] = useState<CompanyInfo>(cached || EMPTY);

  useEffect(() => {
    fetchCompanyInfo().then(setInfo);
  }, []);

  return info;
}
